import React, { Fragment, useEffect, useState } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import toast from 'react-hot-toast';
import { AddRatingApi } from '../Utils/API';
import { useSelector } from 'react-redux';

export default function RateVenueModal({ isOpen, onClose, venueDetails }) {
    const userdetails = useSelector(state => state.user?.userDetails)
    const [rating, setRating] = useState(0);
    const [feedback, setFeedback] = useState('');

    const handleRating = (index) => {
        setRating(index);
    };

    const handleFeedback = () => {
        const payload = {
            rating: rating,
            venue: venueDetails?.id,
            user: userdetails?.id,
            review: feedback
        }
        try {
            AddRatingApi(payload).then(res => {
                if (res?.status == 'success') {
                    toast.success('Rating added successfully');
                    onClose();
                } else {
                    onClose()
                    console.log('error', res?.data?.message)
                }
            })
        } catch (error) {
            console.log('error', error)
            onClose()
        }
    }

    useEffect(() => {
        if (isOpen) {
            setRating(0);
            setFeedback('');
        }
    }, [isOpen]);

    return (
        <>
            <Transition appear show={isOpen} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={onClose}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                    <Dialog.Title
                                        as="h3"
                                        className="text-lg font-medium leading-6 text-gray-900"
                                    >
                                        Battlefields - Maharaj, Chhatrapati Shivaji Maharaj
                                    </Dialog.Title>
                                    <div className="mt-4">
                                        <div className="flex items-center justify-center space-x-1">
                                            {[1, 2, 3, 4, 5].map((index) => (
                                                <button
                                                    key={index}
                                                    onClick={() => handleRating(index)}
                                                >
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        className={`h-8 w-8 ${index <= rating
                                                            ? 'text-yellow-400'
                                                            : 'text-gray-300'
                                                            }`}
                                                        fill="currentColor"
                                                        viewBox="0 0 24 24"
                                                    >
                                                        <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                                                    </svg>
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                    <div className="mt-4">
                                        <textarea
                                            className="w-full p-2 border rounded-md text-gray-700"
                                            rows={13}
                                            cols={10}
                                            placeholder="What can be improved?"
                                            value={feedback}
                                            onChange={(e) => setFeedback(e.target.value)}
                                        />
                                    </div>
                                    <div className="mt-4 flex justify-end space-x-2">
                                        <button
                                            type="button"
                                            className="inline-flex justify-center rounded-md border border-transparent bg-gray-300 px-4 py-2 text-sm font-medium text-gray-800 hover:bg-gray-400"
                                            onClick={onClose}
                                        >
                                            Cancel
                                        </button>
                                        <button
                                            type="button"
                                            className="inline-flex justify-center rounded-md border border-transparent bg-primary px-4 py-2 text-sm font-medium text-white"
                                            onClick={handleFeedback}
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}
